"use client";

import { useEffect, useState } from "react";
import { useAuth } from "@/lib/auth-context";
import { apiGetQuiet, apiPost } from "@/lib/api";
import { Reconnect } from "@/lib/icons";
import { useToast } from "@/components/toast-provider";

export default function RestartButton() {
  const { user } = useAuth();
  const { showToast } = useToast();
  const [allowed, setAllowed] = useState(false);
  const [restarting, setRestarting] = useState(false);

  useEffect(() => {
    if (!user) return;
    apiGetQuiet<{ allowed: boolean }>("/terminal/access")
      .then((res) => setAllowed(res.allowed))
      .catch(() => setAllowed(false));
  }, [user]);

  if (!user || !allowed) return null;

  const handleRestart = async () => {
    setRestarting(true);
    try {
      await apiPost("/terminal/restart", {});
      showToast("success", "Backend restart triggered");
    } catch {
      showToast("error", "Failed to trigger restart");
    } finally {
      setTimeout(() => setRestarting(false), 3000);
    }
  };

  return (
    <button
      onClick={handleRestart}
      disabled={restarting}
      className="text-muted hover:text-accent transition-colors disabled:opacity-40"
      title="Restart backend"
    >
      <span style={{ transform: "scale(1.3)", display: "inline-flex" }}><Reconnect className={restarting ? "animate-spin" : ""} /></span>
    </button>
  );
}
